import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ArticlePage from "./ArticlePage";

const EDITORIAL = ["editor", "admin", "super_admin"];

export default function ArticlePreviewPage() {
  const { user, loading } = useAuth();
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => m.remove();
  }, []);
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!EDITORIAL.includes(user.role)) return <div className="p-12 text-center" data-testid="preview-forbidden">Accès réservé à l'équipe éditoriale.</div>;
  return <ArticlePage preview />;
}
